import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { BasketballStatistic } from './basketball-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: BasketballStatistic,
    competitorTeam: BasketballStatistic
  }
})
export class BasketballGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: BasketballStatistic;
  competitorTeam: BasketballStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
